import { ApiConnectorInstance } from '@/Singletons';

export default class Api {
    // TODO: Remove after services migration
    getHttpClient(includeToken: boolean = true) {
        return ApiConnectorInstance.getHttpClient('oldapi', includeToken);
    }

    getLocalHttpClient(includeToken: boolean = true) {
        return ApiConnectorInstance.getHttpClient('local', includeToken);
    }
}
